/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Video_Url_PlaceholderInputs */

const en_media_import_video_url_placeholder = /** @type {(inputs: Media_Import_Video_Url_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video URL`)
};

const fr_media_import_video_url_placeholder = /** @type {(inputs: Media_Import_Video_Url_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL de la video`)
};

const de_media_import_video_url_placeholder = /** @type {(inputs: Media_Import_Video_Url_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video-URL`)
};

const it_media_import_video_url_placeholder = /** @type {(inputs: Media_Import_Video_Url_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL del video`)
};

const ru_media_import_video_url_placeholder = /** @type {(inputs: Media_Import_Video_Url_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL видео`)
};

const es_media_import_video_url_placeholder = /** @type {(inputs: Media_Import_Video_Url_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL del vídeo`)
};

const zh_cn2_media_import_video_url_placeholder = /** @type {(inputs: Media_Import_Video_Url_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频网址`)
};

const ja_media_import_video_url_placeholder = /** @type {(inputs: Media_Import_Video_Url_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオURL`)
};

const hi_media_import_video_url_placeholder = /** @type {(inputs: Media_Import_Video_Url_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो यूआरएल`)
};

const pt_pt2_media_import_video_url_placeholder = /** @type {(inputs: Media_Import_Video_Url_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL do vídeo`)
};

/**
* | output |
* | --- |
* | "Video URL" |
*
* @param {Media_Import_Video_Url_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_video_url_placeholder = /** @type {((inputs?: Media_Import_Video_Url_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Video_Url_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_video_url_placeholder(inputs)
	if (locale === "de") return de_media_import_video_url_placeholder(inputs)
	if (locale === "it") return it_media_import_video_url_placeholder(inputs)
	if (locale === "ru") return ru_media_import_video_url_placeholder(inputs)
	if (locale === "es") return es_media_import_video_url_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_video_url_placeholder(inputs)
	if (locale === "ja") return ja_media_import_video_url_placeholder(inputs)
	if (locale === "hi") return hi_media_import_video_url_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_video_url_placeholder(inputs)
	return en_media_import_video_url_placeholder(inputs)
});